const mFeedSectionContentCardDesing2 = {
  mFeedSectionContentCardDesing2: {
    accessDenied: 'Deshabilitado',
    accessGranted: 'Acceder',
    available: 'DISPONIBLE',
    draft: 'BORRADOR',
    hidden: 'Oculto',
    notAvailable: 'NO DISPONIBLE',
    noCategoryName: 'SIN CATEGORÍA',
    noprice: 'SIN PRECIO',
    published: 'PUBLICADO',
    visible: 'Visible'
  }
}

export default mFeedSectionContentCardDesing2
